import Vue from "vue";
import VueRouter from "vue-router";
import index from "../components/index.vue";
import gamelist from "../components/gamelist.vue";
import game from "../components/game.vue";
import goodsdetail from "../components/goodsdetail.vue";
import business from "../components/business.vue";
import sell from "../components/sell.vue";
import down from "../components/down.vue";
import zuhaogamelist from "../components/zuhaogamelist.vue";
import login from "../components/login.vue";
import user from "../components/user.vue";
import addorder from "../components/addorder";
import shoucang from "../components/shoucang";
import order from "../components/order";
import editpass from "../components/editpass";
import lottery from "../components/lottery.vue";
import kefu from "../components/kefu.vue";
import admin from "../components/admin.vue";

import orderDetail from "../components/orderDetail";
import shownews from "../components/show_news";

import newsdetail from "../components/news/detail";
import about from "../components/about";
import zhilan from "../components/zhilan";

import gonggao from "../components/gonggao";
import shiming from "../components/shiming";
import chushou from "../components/chushou";
import mygoods from "../components/mygoods";
import money from "../components/money";
import withdraw from "../components/withdraw";
import withdraw_log from "../components/withdraw_log";

import store from '../store'

//重复点击路由报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
var seo_title = '八宝粥商行—三角洲行动哈夫币回收内测老店-24小时人工客服 交易无忧';
var seo_keywords = '账号发布  账号租赁  人工客服 售后专线';
var seo_description = '快氪科技（武汉市）有限公司，成立于湖北省武汉市，注册资本1000万。专注游戏账号及数字资产交易。依托合规的资质 优良的服务 以及完整的售前售后流程，保障每一位客户的权益。';
const routes = [{
		path: "/gamelist",
		name: "gamelist",
		component: gamelist,
		meta: {
			title: "游戏列表-" + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/zuhao",
		name: "zuhao",
		component: zuhaogamelist,
		meta: {
			title: "游戏租号-" + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/game",
		name: "game",
		component: game,
		meta: {
			title: seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		name: 'addorder',
		path: '/addorder',
		component: addorder,
		meta: {
			title: seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/",
		name: "index",
		component: index,
		meta: {
			title: seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/goodsdetail",
		name: "goodsdetail",
		component: goodsdetail,
		meta: {
			title: '账号详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: '/a/:id',
		component: goodsdetail,
		name: "goodsdetail2",
		meta: {
			title: '账号详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/business",
		name: "business",
		component: business,
		meta: {
			title: '帮助中心-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/sell",
		name: "sell",
		component: sell,
		meta: {
			title: '账号估价-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/about",
		name: "about",
		component: about,
		meta: {
			title: '关于我们-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/zhilan",
		name: "zhilan",
		component: zhilan,
		meta: {
			title: '出售指南-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},

	{
		path: "/login",
		name: "login",
		component: login,
		meta: {
			title: '登录-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/user",
		name: "user",
		component: user,
		meta: {
			title: '个人中心-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/shoucang",
		name: "shoucang",
		component: shoucang,
		meta: {
			title: '我的收藏-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/order",
		name: "order",
		component: order,
		meta: {
			title: '我的订单-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/editpass",
		name: "editpass",
		component: editpass,
		meta: {
			title: '修改密码-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/shiming",
		name: "shiming",
		component: shiming,
		meta: {
			title: '实名认证-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/chushou",
		name: "chushou",
		component: chushou,
		meta: {
			title: '信息收集-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/orderDetail",
		name: "orderDetail",
		component: orderDetail,
		meta: {
			title: '订单详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},

	{
		path: "/shownews",
		name: "shownews",
		component: shownews,
		meta: {
			title: '详情-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/mygoods",
		name: "mygoods",
		component: mygoods,
		meta: {
			title: '我的商品-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	
	{
		path: "/money",
		name: "money",
		component: money,
		meta: {
			title: '资金明细-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/withdraw",
		name: "withdraw",
		component: withdraw,
		meta: {
			title: '提现-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/withdraw_log",
		name: "withdraw_log",
		component: withdraw_log,
		meta: {
			title: '提现记录-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: true
		}
	},
	{
		path: "/lottery",
		name: "lottery",
		component: lottery,
		meta: {
			title: '幸运大抽奖-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
		path: "/kefu",
		name: "kefu",
		component: kefu,
		meta: {
			title: '客服通道-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},
	{
			path: "/kefuConfig",
			name: "kefuConfig",
			component: () => import("../components/kefuConfig.vue"),
			meta: {
				title: "客服配置-" + seo_title,
				keywords: seo_keywords,
				description: seo_description,
				auth: true
			}
	},
	{
		path: "/admin",
		name: "admin",
		component: admin,
		meta: {
			title: '后台管理-' + seo_title,
			keywords: seo_keywords,
			description: seo_description,
			auth: false
		}
	},

];

const router = new VueRouter({
	mode: "history",
	routes,
});

router.beforeEach((to, form, next) => {


	// console.log(to)
	if (to.meta.title) {
		document.title = to.meta.title
		document.keywords = to.meta.keywords
		document.description = to.meta.description
	}

	var logined = Boolean(localStorage.getItem('usertoken'))

	if (!logined) {

		if (to.meta.auth) {
			store.commit('SET_open_login', true)
			// next('/login');
		} else {
			next();
		}

	} else {
		next();
	}

});

export default router;